/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* Tools 2U: mega menu category tabs (hover intent, no layout change) + homepage product tabs */
(function () {
  var timer = null;
  function activate(tab) {
    var mm = tab.closest('.t2u-mm');
    if (!mm || tab.classList.contains('is-active')) return;
    var panel = document.getElementById(tab.getAttribute('data-t2u-tab'));
    if (!panel) return;
    var oldTab = mm.querySelector('.t2u-mm__tab.is-active');
    var oldPanel = mm.querySelector('.t2u-mm__panel.is-active');
    if (oldTab) oldTab.classList.remove('is-active');
    if (oldPanel) oldPanel.classList.remove('is-active');
    tab.classList.add('is-active');
    panel.classList.add('is-active');
    checkMore(panel);
  }
  function checkMore(panel) {
    if (!panel) return;
    var stage = panel.closest('.t2u-mm__stage');
    if (!stage) return;
    var more = panel.scrollHeight - panel.clientHeight - panel.scrollTop > 12;
    stage.classList.toggle('has-more', more);
    var label = stage.querySelector('.t2u-mm__more span');
    if (label && more) {
      var tiles = panel.querySelectorAll('.t2u-mm__tiles > li, .t2u-mm__brands > li');
      var cutoff = panel.getBoundingClientRect().bottom - 40, hidden = 0;
      for (var i = tiles.length - 1; i >= 0 && tiles[i].getBoundingClientRect().top > cutoff; i--) hidden++;
      label.firstChild.nodeValue = hidden > 0 ? hidden + ' more – scroll ' : 'Scroll for more ';
    }
  }
  var scrollQueued = false;
  document.addEventListener('scroll', function (event) {
    var el = event.target;
    if (scrollQueued || !el.classList || !el.classList.contains('t2u-mm__panel')) return;
    scrollQueued = true;
    requestAnimationFrame(function () { scrollQueued = false; checkMore(el); });
  }, { capture: true, passive: true });
  /* When a mega menu opens: load its images (only once) and check for overflow */
  function hydrate(mega) {
    var tpl = mega.querySelector('template.t2u-mega__tpl');
    if (tpl) { mega.appendChild(tpl.content.cloneNode(true)); tpl.parentNode.removeChild(tpl); }
  }
  function onOpen(mega) {
    hydrate(mega);
    if (!mega.hasAttribute('data-t2u-loaded')) {
      mega.setAttribute('data-t2u-loaded', '');
      mega.querySelectorAll('img[data-t2u-src]').forEach(function (img) { img.src = img.getAttribute('data-t2u-src'); img.removeAttribute('data-t2u-src'); });
    }
    requestAnimationFrame(function () { checkMore(mega.querySelector('.t2u-mm__panel.is-active')); });
  }
  document.addEventListener('pointerover', function (event) {
    var bar = event.target.closest && event.target.closest('.nav-bar');
    if (!bar || bar.hasAttribute('data-t2u-ready')) return;
    bar.setAttribute('data-t2u-ready', '');
    bar.querySelectorAll('.t2u-mega').forEach(hydrate);
  }, { passive: true });
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) { if (m.target.getAttribute('aria-hidden') === 'false') onOpen(m.target); });
    });
    var watch = function () { document.querySelectorAll('.t2u-mega').forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['aria-hidden'] }); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }
  /* Menu aim: if the pointer is travelling right towards the list, don't switch tabs it merely passes over.
     A tab only switches once the pointer settles on it. */
  var pts = [], hovered = null;
  document.addEventListener('mousemove', function (event) {
    if (!hovered) { if (pts.length) pts.length = 0; return; }
    pts.push({ x: event.clientX, y: event.clientY, t: Date.now() });
    if (pts.length > 6) pts.shift();
  }, { passive: true });
  function headingToPanel() {
    if (pts.length < 2) return false;
    var a = pts[0], b = pts[pts.length - 1];
    var dx = b.x - a.x, dy = Math.abs(b.y - a.y);
    return dx > 1 && dy < dx * 4;
  }
  function schedule(tab) {
    clearTimeout(timer);
    var moving = headingToPanel();
    timer = setTimeout(function () {
      if (hovered !== tab) return;
      if (moving && headingToPanel() && Date.now() - (pts.length ? pts[pts.length - 1].t : 0) < 120) { schedule(tab); return; }
      activate(tab);
    }, moving ? 260 : 70);
  }
  document.addEventListener('mouseover', function (event) {
    var tab = event.target.closest && event.target.closest('[data-t2u-tab]');
    hovered = tab;
    if (!tab) { clearTimeout(timer); return; }
    if (tab.classList.contains('is-active')) { clearTimeout(timer); return; }
    schedule(tab);
  });
  document.addEventListener('focusin', function (event) {
    var tab = event.target.closest && event.target.closest('[data-t2u-tab]');
    if (tab) activate(tab);
  });
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-t2u-ptab]');
    if (!btn) return;
    var section = btn.closest('.t2u-ptabs');
    section.querySelectorAll('[data-t2u-ptab]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(b.getAttribute('data-t2u-ptab'));
      if (panel) panel.classList.toggle('is-active', on);
    });
  });
})();


/* Tools 2U: sticky "Add to basket" bar on product pages */
(function () {
  function init() {
    var bar = document.querySelector('[data-t2u-sticky]');
    if (!bar) return;
    var form = document.getElementById(bar.getAttribute('data-form'));
    if (!form || !form.querySelector('.product-form__add-button')) return;
    var hasOptions = bar.getAttribute('data-has-options') === 'true';
    var btn = bar.querySelector('[data-t2u-sticky-btn]');
    var shown = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('t2u-has-sticky', on);
    }
    /* The product form re-renders on variant change, so look the button up fresh each time (cheap, once per frame). */
    var queued = false;
    function check() {
      queued = false;
      var f = document.getElementById(bar.getAttribute('data-form'));
      var b = f && f.querySelector('.product-form__add-button');
      if (!b) { setShown(false); return; }
      /* show only once the button has scrolled up out of view, not before the user reaches it */
      setShown(b.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
    check();
    btn.addEventListener('click', function () {
      form = document.getElementById(bar.getAttribute('data-form')) || form;
      var current = form.querySelector('.product-form__add-button');
      if (hasOptions || !current || current.disabled) {
        (form.querySelector('.product-form__variants') || current || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      current.click();
    });
    function money(cents) {
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100); } catch (e) { return '£' + (cents / 100).toFixed(2); }
    }
    document.addEventListener('variant:changed', function (event) {
      if (!event.detail || !event.target || event.target.id !== bar.getAttribute('data-form')) return;
      var v = event.detail.variant;
      if (!v) return;
      bar.querySelector('[data-t2u-sticky-price]').textContent = money(v.price);
      var cmp = bar.querySelector('[data-t2u-sticky-compare]');
      if (v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; } else { cmp.hidden = true; }
      var vt = bar.querySelector('[data-t2u-sticky-variant]');
      if (vt) vt.textContent = v.title || '';
      btn.disabled = !v.available;
      btn.textContent = v.available ? (window.languages && window.languages.productFormAddToCart || 'Add to basket') : (window.languages && window.languages.productFormSoldOut || 'Sold out');
      if (v.featured_media && v.featured_media.preview_image) {
        var img = bar.querySelector('.t2u-sticky__img img');
        if (img) img.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---- Mobile search: the X clears the search AND takes you back to the page (theme only cleared it, leaving a blank locked screen) ---- */
(function () {
  function closeMobileSearch(wrapper) {
    var input = wrapper.querySelector('[name="q"]');
    var closeBtn = wrapper.querySelector('[data-action="unfix-search"]');
    if (input) { input.value = ''; input.classList.remove('is-filled'); input.blur(); }
    if (closeBtn) { closeBtn.click(); }
    wrapper.classList.remove('is-fixed');
    document.documentElement.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="clear-input"]');
    if (!btn) return;
    var wrapper = btn.closest('.header__search-bar-wrapper');
    if (!wrapper || !wrapper.classList.contains('is-fixed')) return;
    setTimeout(function () { closeMobileSearch(wrapper); }, 0);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wrapper = document.querySelector('.header__search-bar-wrapper.is-fixed');
    if (wrapper) closeMobileSearch(wrapper);
  });
})();
